"use client";

import SLogo from "@public/image/icon/logo.svg";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useMemo } from "react";
import { HEADER_LINKS } from "@/constants/header";
import { PATH } from "@/constants/path";
import { useBatchImpressionTracking } from "@/hooks/useImpressionTracking";
import { trackEvent } from "@/utils/analytics";
import Button from "../Button";
import HeaderItem from "./atoms/HeaderItem";

function HeaderDesktop() {
  const impressionEvents = useMemo(
    () => [
      { eventName: "gnb_impression", params: { menu_item: "logo", page_location: "/" } },
      ...HEADER_LINKS.map((l) => ({
        eventName: "gnb_impression",
        params: { menu_item: l.label.toLowerCase(), page_location: "/" },
      })),
      { eventName: "gnb_impression", params: { menu_item: "jd_creator", page_location: "/" } },
      { eventName: "cta_impression", params: { cta_type: "demo", cta_position: "gnb" } },
      { eventName: "cta_impression", params: { cta_type: "inquiry", cta_position: "gnb" } },
    ],
    [],
  );

  const headerRef = useBatchImpressionTracking<HTMLDivElement>(impressionEvents);

  const path = usePathname();

  const handleGnbClick = (menuItem: string) => {
    trackEvent("gnb_click", path, {
      menu_item: menuItem,
      page_location: window.location.pathname,
    });
  };

  const handleCtaClick = (ctaType: string) => {
    trackEvent("cta_click", path, {
      cta_type: ctaType,
      cta_position: "gnb",
    });
  };

  return (
    <div
      ref={headerRef}
      className="fixed left-0 top-0 z-50 hidden h-16 w-full items-center justify-center bg-white px-14 header:flex"
    >
      <div className="flex w-full max-w-[1200px] items-center justify-between gap-24">
        {/* 로고 */}
        <Link href={PATH.HOME} onClick={() => handleGnbClick("logo")}>
          <SLogo className="w-32" />
        </Link>

        <nav className="flex gap-20">
          {/* 링크 목록 */}
          <div className="flex items-center gap-2.5 text-16">
            {HEADER_LINKS.map(({ label, href }) => (
              <HeaderItem key={href} href={href} onClick={() => handleGnbClick(label.toLowerCase())}>
                {label}
              </HeaderItem>
            ))}
          </div>
          {/* 버튼 목록 */}
          <div className="flex items-center gap-3">
            <a
              href="https://jd-creator.searchright.net?utm_source=homepage&utm_medium=organic&utm_campaign=header-button&utm_content=jd"
              target="_blank"
              rel="noopener noreferrer"
              className="relative rounded-md border border-primary bg-blue-50 px-4 py-2 text-14 font-normal text-primary"
              onClick={() => handleGnbClick("jd_creator")}
            >
              JD Creator
              <span
                className="absolute -right-2 -top-2 rounded bg-primary px-1.5 py-0.5 text-[10px] font-bold leading-none text-white">
                BETA
              </span>
            </a>
            <Button color="white" size="sm" border="gray" href={PATH.TRIAL_SERVICE} target="_blank" rel="noopener noreferrer"
                    onClick={() => handleCtaClick("demo")}>
              서비스 체험하기
            </Button>
            <Button color="primary" size="sm" href={PATH.REQUEST} onClick={() => handleCtaClick("inquiry")}>
              문의하기
            </Button>
          </div>
        </nav>
      </div>
    </div>
  );
}

export default HeaderDesktop;
